import { Icon } from '../ui/Icon';
import './siteSwitcher.css';

/** The Sarnia family bar: one clear way to hop between the studio site and the builder. */
export function SiteSwitcher() {
  return (
    <nav className="ss-bar" aria-label="Sarnia sites">
      <div className="ss-row">
        <a className="ss-tab" href="https://sarnia.digital/">
          <Icon name="home" size={14} />
          Sarnia Digital <span>Studio</span>
          <Icon name="external" size={12} className="ss-out" />
        </a>
        <a className="ss-tab is-current" href="/" aria-current="page">
          <Icon name="zap" size={14} />
          Sarnia Builder <span>Make a website</span>
        </a>
      </div>
    </nav>
  );
}

export default SiteSwitcher;
